class FAQAccordion {
  constructor() {
    this.init();
  }

  init() {
    const questionHeaders = document.querySelectorAll('.main-faq__question__header');

    questionHeaders.forEach(header => {
      // Évite le double binding (script chargé par plusieurs sections, rechargement dans l'éditeur)
      if (header.dataset.faqBound) return;
      header.dataset.faqBound = 'true';

      header.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleQuestion(header);
      });

      // Gestion du clavier
      header.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleQuestion(header);
        }
      });
    });
  }

  toggleQuestion(header) {
    const isExpanded = header.getAttribute('aria-expanded') === 'true';
    const answer = header.nextElementSibling;
    const icon = header.querySelector('.main-faq__question__icon');

    // Basculer l'état de la question actuelle
    if (isExpanded) {
      this.closeQuestion(header);
    } else {
      this.openQuestion(header);
    }
  }

  openQuestion(header) {
    const answer = header.nextElementSibling;
    const icon = header.querySelector('.main-faq__question__icon');

    header.setAttribute('aria-expanded', 'true');
    answer.classList.add('show');

    // Animation de l'icône
    if (icon) {
      icon.style.transform = 'rotate(180deg)';
    }
  }

  closeQuestion(header) {
    const answer = header.nextElementSibling;
    const icon = header.querySelector('.main-faq__question__icon');

    header.setAttribute('aria-expanded', 'false');
    answer.classList.remove('show');

    // Animation de l'icône
    if (icon) {
      icon.style.transform = 'rotate(0deg)';
    }
  }
}

// Initialisation quand le DOM est prêt
document.addEventListener('DOMContentLoaded', () => {
  new FAQAccordion();
});

// Réinitialisation pour les sections dynamiques Shopify
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.main-faq')) {
    new FAQAccordion();
  }
});